// extracted by mini-css-extract-plugin
export default {"audio":"index_audio__ne5Dp"};